var map = {
	"./character-disappointed.svg": [
		3787,
		1610
	],
	"./character-embarrassed.svg": [
		3788,
		1609
	],
	"./character-greedy.svg": [
		3789,
		1608
	],
	"./character-happy.svg": [
		3790,
		1607
	],
	"./character-sad.svg": [
		3791,
		1606
	],
	"./character-searching.svg": [
		3792,
		1605
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2191;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img lazy ^\.\/character\-.*\.svg$
// module id = 2191
// module chunks = 1612